import { Routes, Route, useLocation, Link, useParams } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import './Pulsar.css';
import {useEffect, useRef } from 'react';
import img1 from './todos_recursos/personajes80.png';
import img2 from './todos_recursos/juegoinfancia.jpg';
import img3 from './todos_recursos/masterSistem.png';
import img4 from './todos_recursos/a-team.jpg';
import img5 from './todos_recursos/snacks.png';
import img6 from './todos_recursos/megaDrive.jpg'
import img7 from './todos_recursos/dragon-ball-z.jpg'
import img8 from './todos_recursos/cine.jpg'
import img9 from './todos_recursos/musi.jpg'
import Games from './Game';
import HistoriaVideojuegos from './articles/historiaVideojuegos';
import Infancia from './articles/juegosinfancia';
import Carbon from './articles/carbonyMasterSistem';
import EquipoA from './articles/elequipoa';
import Tazos from './articles/precioJoven';
import SegaMegaDrive from './articles/megadrive';
import Goku from './articles/superguerrer';
import Cine from './articles/estrenos';
import Musica from './articles/musicaVideojuegos';


function PaginaPrincipal() {

  const location = useLocation();
  
    const scrollPos = useRef(0);
    const datosArticulo = {
      0: { contenido: ""},
      historia_videojuegos: { contenido: <HistoriaVideojuegos/>, titulo: "Historia videojuegos en España"},
      descubrimiento_videojuegos: { contenido: <Infancia/>, titulo: "Descubriendo los 80/90" },
      carbon_y_masterSistem: { contenido: <Carbon/>, titulo: "Carbón y Master Sistem"},
      el_equipo_a: {contenido: <EquipoA/>, titulo: "El equipo A"},
      precio_joven: {contenido: <Tazos/>, titulo: "Precio joven"},
      megadrive: {contenido: <SegaMegaDrive/>, titulo: 'Sega Mega Drive'},
      dragon_ball: {contenido: <Goku/>, titulo: 'Dragon Ball'},
      fiesta_cine: {contenido: <Cine/>, titulo: 'La fiesta del cine'},
      musica_juegos: {contenido: <Musica/>, titulo: 'La música en los videojuegos'}
    };


  useEffect(() => {
    if (location.pathname !== "/") {
      scrollPos.current = window.scrollY;
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        window.scrollTo(0, scrollPos.current);
      }, 10);
    }
  }, [location.pathname]); 

  return (
    <>


<div class="header-glow-wrapper">

  <header className='header-design'>
  <div className="button">Pulsar la tecla</div>
  </header>

</div>


<div className="crt-overlay"></div> 

<section className="contenido">


        
        
            

        <p className="pulsar" id="caja">

        <h2>Tu web de análisis, artículos, curiosidades, historietas...</h2>
        </p>
        
        <br></br>
        
  <TransitionGroup>

    

          <CSSTransition
          appear={true} 
          key={location.key}
          timeout={400}
          classNames="show"
          unmountOnExit>

            <Routes location={location}>

                <Route path="/" element={
          <div className='contenedorPrincipal'>

                  <section className='contenidoHistorietas'>

                    <div className='tituloSeccion'>El muro de las publicaciones</div>

                    <Link to="/articulo/historia_videojuegos" className = "cajaContenido" style={{ '--bg-img': `url(${img1})` }}>
                    <div className="cajaImagen">
                      <span className="tagArticulo">ARTÍCULO</span>
                    </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>Te gustan los videojuegos, pero ¿conoces su verdadera historia?</h5>
                            <p>Descubre los orígenes de las primeras lineas de código que se escribieron en nuestro país.</p>
                          </div>
                          <span className="fechaArticulo">ENERO 2026</span>
                        </div>
                      </Link>

                      <Link to="/articulo/megadrive" className = "cajaContenido" style={{ '--bg-img': `url(${img6})`}}>
                      <div className="cajaImagen">
                        <span className="tagArticulo">ANÁLISIS</span>
                      </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>Sega Mega Drive</h5>
                            <p>Historia y llegada de la máquina de Sega a nuestro país, y algunas curiosidades que llegaron con ella.</p>
                          </div>
                          <span className="fechaArticulo">ENERO 2026</span>
                        </div>
                      </Link>

                      <Link to="/articulo/dragon_ball" className = "cajaContenido" style={{ '--bg-img': `url(${img7})`}}>
                      <div className="cajaImagen">
                        <span className="tagArticulo">ARTÍCULO</span>
                      </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>Llega el anime</h5>
                            <p>Échale un ojo a la magnifica historia de cómo llego el anime a nuestro país de la mano de las cadenas autonómicas.</p>
                          </div>
                          <span className="fechaArticulo">FEBRERO 2026</span>
                        </div>
                      </Link>

                      <Link to="/articulo/musica_juegos" className = "cajaContenido" style={{ '--bg-img': `url(${img9})`}}>
                      <div className="cajaImagen">
                        <span className="tagArticulo">ANÁLISIS</span>
                      </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>La revolución del sonido</h5>
                            <p>Analizamos las bondades que nos trajo la evolución e inclusión del sonido en el sector de los videojuegos.</p>
                          </div>
                          <span className="fechaArticulo">AGOSTO 2026</span>
                        </div>
                      </Link>

                      <Link to="/articulo/descubrimiento_videojuegos" className = "cajaContenido" style={{ '--bg-img': `url(${img2})`}}>
                      <div className="cajaImagen">
                        <span className="tagArticulo">HISTORIA</span>
                      </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>El descubrimiento de los videojuegos</h5>
                            <p>¿Recuerdas aquellos primeros juegos que llegaron a tus manos?</p>
                          </div>
                          <span className="fechaArticulo">ENERO 2026</span>
                        </div>
                      </Link>
      
                      <Link to="/articulo/carbon_y_masterSistem" className = "cajaContenido" style={{ '--bg-img': `url(${img3})`}}>
                      <div className="cajaImagen">
                        <span className="tagArticulo">HISTORIA</span>
                      </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>Carbón y Master Sistem</h5>
                            <p>Las maravillosas navidades de los años 90... ¿Cómo no echarlas de menos?</p>
                          </div>
                          <span className="fechaArticulo">FEBRERO 2026</span>
                        </div>
                      </Link>

                      <Link to="/articulo/el_equipo_a" className = "cajaContenido" style={{ '--bg-img': `url(${img4})`}}>
                      <div className="cajaImagen">
                        <span className="tagArticulo">HISTORIA</span>
                      </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>Soldados de fortuna...</h5>
                            <p>Algo que tuvieron los 80 es sin duda el gran repertorio de series que nos dejaron. Héroes y villanos que amenizaban los largos días de verano.</p>
                          </div>
                          <span className="fechaArticulo">MARZO 2026</span>
                        </div>
                      </Link>

                      <Link to="/articulo/precio_joven" className = "cajaContenido" style={{ '--bg-img': `url(${img5})`}}>
                      <div className="cajaImagen">
                        <span className="tagArticulo">HISTORIA</span>
                      </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>Por 25 pesetas</h5>
                            <p>Una de las mejores promociones que vivimos y que es imposible de olvidar.</p>
                          </div>
                          <span className="fechaArticulo">ABRIL 2026</span>
                        </div>
                      </Link>

                      <Link to="/articulo/fiesta_cine" className = "cajaContenido" style={{ '--bg-img': `url(${img8})`}}>
                      <div className="cajaImagen">
                        <span className="tagArticulo">HISTORIA</span>
                      </div>
                        <div className="cajaTexto">
                          <div className="cajaTextoEncabezado">
                            <h5>La fiesta del cine</h5>
                            <p>Existió un tiempo en que ir al cine era sinónimo de fiesta y de encuentro familiar.</p>
                          </div>
                          <span className="fechaArticulo">MAYO 2026</span>
                        </div>
                      </Link>
                  </section>
          
          </div>
            } />
          <Route path="/articulo/:id" element={<Contenedor datosArticulo={datosArticulo} />} />

            </Routes>
          </CSSTransition>
        </TransitionGroup>
      </section>

    <div className="contenedor-redes">
    <span>SÍGUENOS EN</span>
    <a 
      href="https://x.com/PulsarLaTecla" 
      target="_blank" 
      rel="noopener noreferrer"
      className="enlace-x"
    >
      
      <svg viewBox="0 0 24 24" className="icono-x">
        <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24h-2.19L17.61 20.644Z" />
      </svg>
      @PulsarLaTecla
    </a>
  </div>

    <footer>

    <div class="boton"  >© Todos los derechos<br />reservados, Enero 2026</div>
    <a class="boton" href="mailto:contacto@pulsarlatecla.es" >Contacto</a>
    
    <div class="buttonH" >Open<br />24h</div>

  </footer>
          
        


</>
  );
}

function Contenedor({ datosArticulo }) {
  const { id } = useParams(); 
  const articulo = datosArticulo[id];

  useEffect(() => {
    if (articulo) {
      // Esto cambia el texto de la pestaña del navegador
      document.title = `${articulo.titulo} | Pulsar la Tecla`;
    }
    return () => {
      document.title = "Pulsar la Tecla";
    };
  }, [id, articulo]);

  return (
    <div>
      <Games contenido={articulo.contenido} id ={id}  titulo={articulo.titulo} />
      <Link to="/" className="volver">
        <div className="buttonReturn" id="inicial">Volver</div>
      </Link>
    </div>
  );
}

export default PaginaPrincipal;